import { usePostApiProjectsByProjectIdDescriptionMutation } from "api/generatedApi";
import type { GetProjectResponse, DocumentReferenceResponse } from "api/generatedApi";
import { useDialog } from "shared/dialog/use-dialog";
import { ResultDialogType, useMutation } from "utils/hooks/use-mutation";
import { SubmitHandler } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DocumentationModal, CreateProjectFormData } from "../documentation-modal";
import { MaxProjectDescriptionLength } from "components/page/projects/project-setup/project-info-step/project-info-step";

interface Props {
  project: GetProjectResponse;
  documents: DocumentReferenceResponse[];
  handleFileChange: (file: File) => Promise<void>;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  clickDocumentDelete: (documents: DocumentReferenceResponse) => void;
}

export function useDocumentationModal(props: Props) {
  const { project, clickDocumentDelete } = props;
  const { t } = useTranslation();
  const [openDocumentationModal, closeDocumentationModal] = useDialog(DocumentationModal);
  const [editDescription] = usePostApiProjectsByProjectIdDescriptionMutation();

  const wrapMutation = useMutation({
    onSuccess: closeDocumentationModal,
    successProps: {
      description: t("folder.editDescription.success.description"),
    },
    resultDialogType: ResultDialogType.Toast,
  });

  const handleSubmit: SubmitHandler<CreateProjectFormData> = (data) => {
    wrapMutation(
      editDescription({
        projectId: project.id ? project.id : "",
        updateProjectDescriptionRequest: {
          projectDescription: data.description?.slice(0, MaxProjectDescriptionLength),
        },
      })
    );
  };

  const handleClick = () => {
    openDocumentationModal({
      project: project,
      onSubmit: handleSubmit,
      documents: props.documents,
      handleFileChange: props.handleFileChange,
      fileOnChange: props.onChange,
      clickDocumentDelete: clickDocumentDelete,
      onClose: () => {
        closeDocumentationModal();
      },
    });
  };

  return handleClick;
}
